import {
  IntegrationsApi,
  type IIntegrationKey,
  type IResponseMergeField,
} from 'entities/Integrations'
import type { IntegrationFieldLoader } from '../types/IntegrationFieldLoader'

export class GenericFieldLoader implements IntegrationFieldLoader {
  constructor(private integrationKey: IIntegrationKey) {}

  useGenericApi(): boolean {
    return true // Uses the generic getAllFields API
  }

  async loadAllFields(): Promise<IResponseMergeField[]> {
    const { data } = await IntegrationsApi.getIntegrationsByKeyFields(this.integrationKey)
    return data
  }
}
